import React from 'react';
import { PlanCards } from './PlanCards';
import { Emoji } from './Emoji';
import { useCountdown } from '../hooks/useCountdown';
export function Oferta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section id="planes" className="w-full" data-id="element-139" data-mp="ji02ns5t07bz">
      <div className="w-full bg-red-100 py-12 sm:py-14" data-id="element-140" data-mp="3ivke3wnmyhn1">
        <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6" data-id="element-141" data-mp="3ix3oj6mm1ygw">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.25rem,5.5vw,1.875rem)] font-extrabold uppercase leading-tight tracking-tight text-red-800" data-id="element-142" data-mp="3nudpnjjd3ykk">
            <Emoji symbol="⏰" data-id="element-143" data-mp="qpehirgq8ns" />
            Precio de lanzamiento — cierra en:
          </h2>

          <div className="mt-7 flex items-start justify-center gap-2 sm:gap-6" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-144" data-mp="174yeudmw4t43">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-145" data-mp="1it26l4fju5ss" data-mpi={index}>
                <div data-id="element-146" data-mp="1dt61t2z12ac6">
                  <span className="block font-display text-[clamp(2.25rem,12vw,4.5rem)] font-black leading-none tabular-nums text-red-600" data-id="element-147" data-mp="1dsmtmdz6j0bc">
                    {unit.value}
                  </span>
                  <span className="mt-2 block font-display text-[11px] font-bold uppercase tracking-[0.14em] text-red-700/70 sm:text-sm" data-id="element-148" data-mp="14szrtr2jfshr">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="font-display text-[clamp(2.25rem,12vw,4.5rem)] font-black leading-none text-red-300" data-id="element-149" data-mp="v0lrn2r3ytxp">
                    :
                  </span> : null}
              </React.Fragment>)}
          </div>

          <p className="mt-7 inline-flex flex-wrap items-center justify-center gap-2 font-display text-[14px] font-bold text-ink-900 sm:text-xl" data-id="element-150" data-mp="h4gkpev85lr9">
            <Emoji symbol="⚠️" data-id="element-151" data-mp="bh4xseke8d9t" />
            Después sube <span className="text-red-600" data-id="element-152" data-mp="bi7ksbelhvkg">$10.000 ARS</span>. No
            vuelve.
          </p>

          <div className="mt-9" data-id="element-153" data-mp="3tnt1bzzsosdd">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1" data-id="element-154" data-mp="3toueca0dfoxq">
              <span className="inline-flex items-center gap-2 font-display text-[12px] font-bold text-red-700 sm:text-base" data-id="element-155" data-mp="2gq8z5880g1k">
                <Emoji symbol="🔴" data-id="element-156" data-mp="u7mnea9xisqy" />
                Cupos al precio de lanzamiento
              </span>
              <span className="font-display text-[12px] font-extrabold text-ink-900 sm:text-base" data-id="element-157" data-mp="gg950znrc0xi">
                Quedan pocos
              </span>
            </div>
            <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white sm:h-3.5" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-158" data-mp="ldhr3bc10p41">
              <span className="block h-full w-[72%] rounded-full bg-red-600" data-id="element-159" data-mp="1n82kpkirfv03" />
            </div>
            <p className="mt-3 text-right text-[12px] text-ink-500 sm:text-sm" data-id="element-160" data-mp="1j70vzxmgz1cd">
              72% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="w-full bg-white py-14 sm:py-16" data-id="element-161" data-mp="1s3hy6bcuvovz">
        <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-content" data-id="element-162" data-mp="14cchxv306ul5">
          <h2 className="text-center font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase tracking-tight text-ink-900" data-id="element-163" data-mp="10ar68d27gmcj">
            Elegí tu <span className="text-celeste-600" data-id="element-164" data-mp="1e7ny8hu289v0">MegaPack</span>
          </h2>

          <div className="mt-10 sm:mt-12" data-id="element-165" data-mp="1992yejipzs73">
            <PlanCards data-id="element-166" data-mp="2ponol7wukeme" />
          </div>
        </div>
      </div>
    </section>;
}